import { FC } from 'react'
import { CheckboxWithLabel, CheckboxWithLabelProps } from './CheckboxWithLabel'

export type AllSelectorProps = CheckboxWithLabelProps

export const AllSelector: FC<AllSelectorProps> = (props) => (
  <CheckboxWithLabel {...props} />
)
